export default {
  init() {
    this.addClassEvenBlock();
    this.initStickyHeader();
  },
  addClassEvenBlock() {
    const elements = document.querySelectorAll(".block__content__bg");

    elements.forEach((el, index) => {
      if (index % 2 !== 0) {
        el.classList.add("block__content__bg--even");
      }
    });
  },
  initStickyHeader() {
    const header = document.querySelector("header");
    let isScrolled = false;

    if (!header) return;

    const handleScroll = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const shouldBeScrolled = scrollTop > 50; // Trigger after 50px of scroll

      if (shouldBeScrolled && !isScrolled) {
        header.classList.add("header--scrolled");
        isScrolled = true;
      } else if (!shouldBeScrolled && isScrolled) {
        header.classList.remove("header--scrolled");
        isScrolled = false;
      }
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll, { passive: true });

    // Check initial scroll position
    handleScroll();
  },
};
